<div>
  <app-asset-list-header
    [title]="'HEADER_TITLE.UTILITY_MANAGEMENT'"
    [hideAddNew]="false"
    [addNewText]="'COMMON.TABLE_HEADERS.UTILITY'"
    [hideDropdown]="true"
    (addNewClicked)="handleAddNew()"
  ></app-asset-list-header>

  <div class="filter-bar">
    <div class="search-bar">
      <img
        src="assets/icons/search.svg"
        alt="Search icon"
        class="search-icon"
      />
      <input
        type="text"
        class="search-input"
        [placeholder]="'COMMON.SEARCH' | translate"
        [(ngModel)]="searchText"
        (keydown.enter)="search()"
        (ngModelChange)="this.searchTextUpdate.next($event)"
      />
    </div>
  </div>

  <div class="divider-horizontal"></div>

  <div class="utility-table-wrapper">
    <div class="utility-table">
      <div *ngFor="let utility of utilities" class="utility-card">
        <!-- Logo -->
        <div>
          <img
            class="utility-logo"
            [src]="utility.imageUrl"
            [alt]="utility.name + ' Logo'"
          />
        </div>

        <!-- Full name -->
        <div class="utility-fullname">
          {{ utility.fullName | hasValue }}
        </div>

        <!-- Acronym & Color code -->
        <div class="abbr-color">
          <span class="short-name">{{ utility.name | hasValue }}</span>
          <span class="status-badge">
            <span
              class="status-dot"
              [style.background]="utility.colorCode"
            ></span>
            <span class="status-code">{{ utility.colorCode | hasValue }}</span>
          </span>
        </div>

        <div class="divider"></div>

        <!-- Flag & Currency -->
        <div class="utility-region">
          <img
            *ngIf="utility.countryCode; else noFlag"
            class="flag"
            [src]="
              'https://flagcdn.com/w160/' +
              utility.countryCode.toLowerCase() +
              '.png'
            "
            [alt]="utility.countryCode"
          />
          <span class="region">
            {{ getCountryName(utility.countryCode) | hasValue }} :
            {{ utility.countryCurrency | hasValue }}
          </span>

          <ng-template #noFlag>
            <span class="region">{{ utility.countryCode | hasValue }}</span>
          </ng-template>
        </div>

        <!-- Subdomain -->
        <div class="utility-domain">
          <a
            class="domain-box"
            (click)="openUtilityPortal(utility.id, utility.subDomain)"
          >
            <span class="domain-text">
              {{ utility.subDomain | hasValue }}
            </span>
          </a>
        </div>

        <!-- Status -->
        <div class="utility-status">
          <span
            class="status"
            [ngClass]="{
              green: utility.status.toLowerCase() === 'active',
              red: utility.status.toLowerCase() === 'inactive'
            }"
          >
            {{ utility.status | hasValue }}
          </span>
        </div>

        <!-- Deployment Status -->
        <div
          class="utility-status clickable"
          (click)="openUtilityDeploymentStatusesModal(utility.id)"
        >
          <span
            class="status"
            [ngClass]="{
              green: utility.deploymentStatus.toLowerCase() === 'successful',
              gray:
                utility.deploymentStatus.toLowerCase() === 'none' ||
                utility.deploymentStatus.toLowerCase() === 'inprogress',
              red: utility.deploymentStatus.toLowerCase() === 'failed'
            }"
          >
            {{ utility.deploymentStatus | deploymentStatus }}
          </span>
        </div>

        <!-- Dropdown -->
        <div class="more-icon">
          <div
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img
              src="../../assets/icons/more-icon.svg"
              alt="More icon"
              class="clickable"
            />
          </div>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li (click)="openDetailsInNewTab(utility.id)">
              <img
                src="../../assets/icons/open-utility.svg"
                alt="Open utility icon"
              />
              <span
                >{{ "COMMON.OPEN" | translate }}
                {{
                  "COMMON.TABLE_HEADERS.UTILITY" | translate | lowercase
                }}</span
              >
            </li>
            <li (click)="onEditClicked(utility.id)">
              <img
                src="../../assets/icons/edit-utility.svg"
                alt="Edit utility icon"
              />
              <span
                >{{ "COMMON.EDIT" | translate }}
                {{
                  "COMMON.TABLE_HEADERS.UTILITY" | translate | lowercase
                }}</span
              >
            </li>
            <li
              *ngIf="utility.status === 'Active'; else activateUser"
              (click)="onSetStatus(utility.id, utility.status)"
            >
              <img
                src="../../assets/icons/activate-utility.svg"
                alt="Deactivate utility icon"
              />
              <span
                >{{ "COMMON.DEACTIVATE" | translate }}
                {{
                  "COMMON.TABLE_HEADERS.UTILITY" | translate | lowercase
                }}</span
              >
            </li>
            <ng-template #activateUser>
              <li (click)="onSetStatus(utility.id, utility.status)">
                <img
                  src="../../assets/icons/activate-utility.svg"
                  alt="Activate utility icon"
                />
                <span
                  >{{ "COMMON.ACTIVATE" | translate }}
                  {{
                    "COMMON.TABLE_HEADERS.UTILITY" | translate | lowercase
                  }}</span
                >
              </li>
            </ng-template>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="pagination">
    <app-asset-list-pagination
      [pageFromList]="currentPage"
      (pageChanged)="reloadTable($event)"
      [itemsPerPage]="5"
      [totalItems]="count"
    ></app-asset-list-pagination>
  </div>
</div>

<div
  class="modal fade"
  id="utilityDeploymentModal"
  tabindex="-1"
  aria-labelledby="utilityDeploymentModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="utilityDeploymentModalLabel">
          {{ "UTILITY_MANAGEMENT.DEPLOYMENT_STATUSES" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div *ngIf="selectedUtility; else noUtility" class="status-container">
          <div class="status-item">
            <span class="info-label">{{
              "UTILITY_MANAGEMENT.INITIAL_CREATE" | translate
            }}</span>
            <span
              class="status-value"
              [ngClass]="
                getStatusClass(selectedUtility.deploymentInitialCreation)
              "
            >
              {{ selectedUtility.deploymentInitialCreation | deploymentStatus }}
            </span>
          </div>
          <div class="status-item">
            <span class="info-label">{{
              "UTILITY_MANAGEMENT.PDF_GENERATION" | translate
            }}</span>
            <span
              class="status-value"
              [ngClass]="
                getStatusClass(selectedUtility.deploymentPdfGeneration)
              "
            >
              {{ selectedUtility.deploymentPdfGeneration | deploymentStatus }}
            </span>
          </div>
          <div
            class="status-item"
            [ngClass]="{
              clickable:
                selectedUtility.deploymentSubdomainCreation === 'InProgress' ||
                selectedUtility.deploymentSubdomainCreation === 'Failed'
            }"
            (click)="
              (selectedUtility.deploymentSubdomainCreation === 'InProgress' ||
                selectedUtility.deploymentSubdomainCreation === 'Failed') &&
                retrySubdomainCreation(selectedUtility.id)
            "
          >
            <span class="info-label">{{
              "UTILITY_MANAGEMENT.SUBDOMAIN_CREATION" | translate
            }}</span>
            <span
              class="status-value"
              [ngClass]="
                getStatusClass(selectedUtility.deploymentSubdomainCreation)
              "
            >
              {{
                selectedUtility.deploymentSubdomainCreation | deploymentStatus
              }}
            </span>
          </div>
          <div
            class="status-item"
            [ngClass]="{
              clickable:
                selectedUtility.deploymentDatabasesCreation === 'InProgress' ||
                selectedUtility.deploymentDatabasesCreation === 'Failed'
            }"
            (click)="
              (selectedUtility.deploymentDatabasesCreation === 'InProgress' ||
                selectedUtility.deploymentDatabasesCreation === 'Failed') &&
                retryDatabaseCreation(selectedUtility.id)
            "
          >
            <span class="info-label">{{
              "UTILITY_MANAGEMENT.DATABASE_CREATION" | translate
            }}</span>
            <span
              class="status-value"
              [ngClass]="
                getStatusClass(selectedUtility.deploymentDatabasesCreation)
              "
            >
              {{
                selectedUtility.deploymentDatabasesCreation | deploymentStatus
              }}
            </span>
          </div>
          <div class="status-item">
            <span class="info-label">{{
              "UTILITY_MANAGEMENT.CONFIGURATION_COPY" | translate
            }}</span>
            <span
              class="status-value"
              [ngClass]="
                getStatusClass(selectedUtility.deploymentConfigurationCopy)
              "
            >
              {{
                selectedUtility.deploymentConfigurationCopy | deploymentStatus
              }}
            </span>
          </div>
        </div>
        <ng-template #noUtility>
          <p class="no-data">
            {{ "UTILITY_MANAGEMENT.NO_UTILITY_MESSAGE" | translate }}
          </p>
        </ng-template>
      </div>
    </div>
  </div>
</div>
